import { Copy, MoreVertical, Pause, Trash2 } from "lucide-react";
import { Button } from "../../../components/tailwind/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "../../../components/tailwind/dropdown-menu";
import { canPauseWorkflow } from "../utils/workflowListUtils";
import { workflowTheme } from "../utils/workflowBuilderTheme";

export function WorkflowActions({
  workflow,
  archiveLoading,
  pauseLoading,
  deleteLoading,
  onClone,
  onArchive,
  onPause,
  onDelete
}) {
  const showPause = canPauseWorkflow(workflow);

  const menuItems = [
    {
      label: "Clone",
      icon: Copy,
      onClick: onClone,
    },
    ...(showPause
      ? [{
          label: "Pause workflow",
          icon: Pause,
          disabled: pauseLoading,
          onClick: onPause,
        }]
      : []),
    // {
    //   label: "Archive",
    //   icon: Archive,
    //   disabled: archiveLoading,
    //   onClick: onArchive,
    // },
    {
      label: "Delete",
      icon: Trash2,
      className: "text-red-600 focus:text-red-600 dark:text-red-400 dark:focus:text-red-400",
      disabled: deleteLoading,
      onClick: onDelete,
    },
  ];

  return (
    <div
      className="shrink-0"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className={`h-9 w-9 border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 ${workflowTheme.textSecondary}`}
            aria-label="Workflow actions"
          >
            <MoreVertical className="w-[18px] h-[18px]" strokeWidth={2.25} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <DropdownMenuItem
                key={index}
                className={`gap-2 cursor-pointer ${item.className || ""}`}
                disabled={item.disabled}
                onClick={(event) => item.onClick?.(event, workflow)}
              >
                <Icon
                  className={`w-4 h-4 ${item.iconClassName || ""}`}
                  strokeWidth={2.25}
                />
                {item.label}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
